import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import {HashRouter, Route, Routes,} from 'react-router-dom';
import HomeScreen from './Screen/HomeScreen';
import ProductScreen from './Screen/ProductScreen';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {useContext, useEffect, useState} from 'react';
import {Store} from './Store';
import CartScreen from './Screen/CartScreen';
import SigningScreen from './Screen/SigningScreen';
import ShippingAddressScreen from './Screen/ShippingAddressScreen';
import SignupScreen from './Screen/SignupScreen';
import PaymentMethodScreen from './Screen/PaymentMethodScreen';
import PlaceOrderScreen from './Screen/PlaceOrderScreen';
import OrderScreen from './Screen/OrderScreen';
import OrderHistory from './Screen/OrderHistory';
import ProfileScreen from './Screen/ProfileScreen';
import TreeScreen from './Screen/TreeScreen';
import ProtectedRoute from './component/ProtectedRoute';
import AdminRoute from './component/AdminRoute';
import DashboardScreen from './Screen/Admin/DashboardScreen';
import ProductListScreen from './Screen/Admin/ProductListScreen';
import DeveloperScreen from './Screen/Admin/DeveloperScreen';
import AppControlScreen from './Screen/Admin/AppControlScreen';
import AppReleasesScreen from './Screen/Admin/AppReleasesScreen';
import DownloadAppScreen from './Screen/DownloadAppScreen';
import BroadcastScreen from './Screen/Admin/BroadcastScreen';
import RemoteControlScreen from './Screen/Admin/RemoteControlScreen';
import MessageTemplatesScreen from './Screen/Admin/MessageTemplatesScreen';
import DeveloperGate from './component/DeveloperGate';
import StaffRoute from './component/StaffRoute';
import StockScreen from './Screen/Admin/StockScreen';
import DeliveryScreen from './Screen/Admin/DeliveryScreen';
import InventoryLogScreen from './Screen/Admin/InventoryLogScreen';
import MyDeliveryScreen from './Screen/MyDeliveryScreen';
import AdminOtpHistoryScreen from './Screen/Admin/AdminOtpHistoryScreen';
import ReportsHomeScreen from './Screen/Admin/Reports/ReportsHomeScreen';
import OwnerReportScreen from './Screen/Admin/Reports/OwnerReportScreen';
import UserOtpHistoryScreen from './Screen/UserOtpHistoryScreen';
import ShoppingBalanceLogScreen from './Screen/ShoppingBalanceLogScreen';
import ProductEditScreen from './Screen/Admin/ProductEditScreen';
import OrderListScreen from './Screen/Admin/OrderListScreen';
import UserListScreen from './Screen/Admin/UserListScreen';
import AdminTreeScreen from './Screen/Admin/AdminTreeScreen';
import AddUserScreen from './Screen/AddUserScreen';
import {Helmet} from 'react-helmet-async';
import PointsScreen from './Screen/Admin/PointScreen';
import CommissionScreen from './Screen/Admin/CommissionScreen';
import AvailableBalanceListScreen from './Screen/Admin/AvailableBalanceListScreen';
import UserNotificationScreen from './Screen/userNotificationScreen';
import DesignationListScreen from './Screen/Admin/DesignationListScreen';
import UserPanelScreen from './Screen/UserPanelScreen';
import axios from 'axios';
import TransectionScreen from './Screen/TransectionScreen';
import MyWalletScreen from './Screen/MyWalletScreen';
import MyRegisterWalletScreen from './Screen/RegisterWalletScreen';
import TransferandHistory from './Screen/TransferandHistoryScreen';
import ConvertScreen from './Screen/ConvertScreen';
import TransferScreen from './Screen/TransferScreen';
import HistoryScreen from './Screen/HistoryScreen';
import ConvertHistoryScreen from './Screen/ConvertHistory';
import TransferHistoryScreen from './Screen/TransferHisotryScreen';
import ReferenceHistoryScreen from './Screen/ReferenceHistory';
import PsiHistoryScreen from './Screen/PsiHistoryScreen';
import ShopScreen from './Screen/ShopScreen';
import EcommerceScreen from './Screen/EcommerceScreen';
import SalesandPromotionScreen from './Screen/SalesandPromotion';
import WithdrawScreen from './Screen/WithdrawScreen';
import WithdrawHistoryScreen from './Screen/WithdrawHistoryScreen';
import SalesScreen from './Screen/SalesScreen';
import MySalesScreen from './Screen/MySalesScreen';
import SettingScreen from './Screen/SettingScreen';
import ConfigScreen from './Screen/Admin/ConfigScreen';
import MoneyControlScreen from './Screen/Admin/MoneyControlScreen';
import MessageCenterScreen from './Screen/Admin/MessageCenterScreen';
import ProfileEditLimitScreen from './Screen/Admin/ProfileEditLimitScreen';
import ProfileEditHistoryScreen from './Screen/Admin/ProfileEditHistoryScreen';
import TopupScreen from './Screen/TopupScreen';
import MerchantWithdrawRequestsScreen from './Screen/MerchantWithdrawRequestsScreen';
import RequestMoneyScreen from './Screen/RequestMoneyScreen';
import TopupManageScreen from './Screen/Admin/TopupManageScreen';
import TopupSettingScreen from './Screen/Admin/TopupSettingScreen';
import AgentListScreen from './Screen/Admin/AgentListScreen';
import AddAgentScreen from './Screen/Admin/AddAgentScreen';
import AdminWithdrawScreen from './Screen/Admin/AdminWithdrawScreen';
import AssociationScreen from './Screen/Admin/AssociationScreen';
import AssociationTransferScreen from './Screen/Admin/AssociationTransferScreen';
import MoneyRequestsScreen from './Screen/Admin/MoneyRequestsScreen';
import UserReportScreen from './Screen/Admin/UserReportScreen';
import GroupSalesHistoryScreen from './Screen/GroupSalesHistoryScreen';
import AdminPositionHistory from './Screen/Admin/AdminPostionHistory';
import MyPromotionalStatus from './Screen/MyPromotionalStaus';
import MyPromotionalHistory from './Screen/MyPromotionalHistory';
import MyTeamPromotionalHistory from './Screen/MyTeamPromotionalHistory';
import TeamSales from './Screen/TeamSales';
import RewardHistory from './Screen/RewardHistory';
import AdminSideBar from './component/AdminSideBar';
import GlobalSales from './Screen/Admin/GlobalSales';
import AllBrandScreen from './Screen/AllBrandScreen';
import SearchScreen from './Screen/SearchScreen';
import AgentDashboardScreen from './Screen/Agent/AgentDashboardScreen';
import AgentRoute from './Screen/Agent/AgentRoute';
import ProductManagerRoute from './Screen/ProductManager/ProductManagerRoute';
import ProductManagerDashboard from './Screen/ProductManager/ProductManagerDashboard';
import SalesReportScreen from './Screen/ProductManager/SalesReportScreen';
import OrderReportScreen from './Screen/ProductManager/OrderReportScreen';
import AgentSideBar from './component/AgentSideBar';
import UserManagerRoute from './component/UserManagerRoute';
import UserManagerSideBar from './component/UserManagerSideBar';
import AddUserManagerScreen from './Screen/Admin/AddUserManagerScreen';
import ReceivedHistory from './Screen/ReceivedHistory';
import NoticeListScreen from './Screen/Admin/NoticeListScreen';
import ChatScreen from './Screen/ChatScreen';
import ChatListScreen from './Screen/Admin/ChatListScreen';
import EditUser from './Screen/Admin/EditUser';
import InvoicePDF from './Screen/InvoicePDF';
import InvoicePDFNew from './Screen/InvoicePDFNew';
import WithdrawInvoicePDF from './Screen/WithdrawInvoicePDF';
import GlobalScreen from './Screen/Admin/GlobalScreen';
import TodaySalesScreen from './Screen/TodaySalesScreen';

import CreatedIdsScreen from './Screen/CreatedIdsScreen';

import DistributeScreen from './Screen/Admin/DistributeScreen';
import BackupScreen from './Screen/Admin/BackupScreen';
import Rokey from './ecommerce/Rokey';
import GlobalSalesScreen from './Screen/GlobalSalesScreen';
import Home from './icon/pages/home/Home';
import IncomeGenerationHistory from './Screen/IncomeGenerationHistory';
import SelectGeneration from './Screen/SelectGeneration';
import SystemMonitorScreen from './Screen/Admin/SystemMonitorScreen';
import MatchingHistoryScreen from './Screen/Admin/MatchingHistoryScreen';
import AdminConvertHistoryScreen from './Screen/Admin/ConvertHistoryScreen';
import IncomeGenerationAdminScreen from './Screen/Admin/IncomeGenerationAdminScreen';
import SalesGenerationAdminScreen from './Screen/Admin/SalesGenerationAdminScreen';
import {api} from "./Api";
import { signOutEverywhere } from "./sessionGuard";

function App() {
  const { state, dispatch: ctxDispatch } = useContext(Store);
  const { cart, userInfo } = state;
  const [config, setConfig] = useState();

  const signoutHandler = () => {
    ctxDispatch({ type: 'USER_SIGNOUT' });
    // Ends the session server-side too, so the token is dead everywhere and not
    // merely forgotten by this browser.
    signOutEverywhere().finally(() => {
      window.location.href = '/signin';
    });
  };

  useEffect(() => {
    let active = true;
    const doFetch = async () => {
      try {
        const { data } = await axios.get(api + `/api/users/getconfig`);
        if (!active) return;
        if (data.siteStatus === 0 && (!userInfo || !userInfo.isAdmin)) {
          signoutHandler();
        }
        setConfig(data);
      } catch (error) {}
    };
    doFetch();

    // Heartbeat for active session tracking
    let heartbeatInterval;
    if (userInfo && userInfo.token) {
      const sendHeartbeat = async () => {
        try {
          await axios.post(api + '/api/admin/heartbeat', {}, {
            headers: { Authorization: `Bearer ${userInfo.token}` },
          });
        } catch {}
      };
      sendHeartbeat();
      heartbeatInterval = setInterval(sendHeartbeat, 60000);
    }

    return () => { active = false; if (heartbeatInterval) clearInterval(heartbeatInterval); };
  }, []);

  return (
		<HashRouter>
			<Helmet>
				<title>ClickCart</title>
			</Helmet>
			<div className="d-flex flex-column site-container">
				<ToastContainer position="bottom-center" limit={1} autoClose={1000} />
				<header></header>

				<main>
					{userInfo && userInfo.isAdmin && <AdminSideBar />}
					{/* One staff portal. Agents, user managers and product managers
					    all use the agent sidebar; it shows each section based on the
					    permissions that user holds. */}
					{userInfo &&
						!userInfo.isAdmin &&
						(userInfo.isAgent ||
							userInfo.isUserManager ||
							userInfo.isProductManager) && <AgentSideBar />}
					<Routes>
						<Route path="/" element={<Home />} />
						<Route path="/old" element={<HomeScreen />} />
						<Route path="/rokey" element={<Rokey />} />
						<Route path="/cart" element={<CartScreen />} />
						<Route path="/allbrand" element={<AllBrandScreen />} />
						<Route path="/search" element={<SearchScreen />} />
						<Route path="/signin" element={<SigningScreen />} />
						<Route path="/download-app" element={<DownloadAppScreen />} />
						<Route path="/signup" element={<SignupScreen />} />
						<Route path="/shipping" element={<ShippingAddressScreen />} />
						<Route path="/payment" element={<PaymentMethodScreen />} />
						<Route path="/placeorder" element={<PlaceOrderScreen />} />
						<Route path="/notification" element={<UserNotificationScreen />} />
						<Route path="/product/:slug" element={<ProductScreen />} />

						<Route
							path="/chat"
							element={
								<ProtectedRoute>
									<ChatScreen />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/order/:id"
							element={
								<ProtectedRoute>
									<OrderScreen />
								</ProtectedRoute>
							}
						/>
						<Route path="/invoice/:id" element={<ProtectedRoute><InvoicePDF /></ProtectedRoute>} />
						<Route path="/invoice-new/:id" element={<ProtectedRoute><InvoicePDFNew /></ProtectedRoute>} />
						<Route
							path="/withdrawinvoice/:id"
							element={
								<ProtectedRoute>
									<WithdrawInvoicePDF />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/orderhistory"
							element={
								<ProtectedRoute>
									<OrderHistory />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/user-panel"
							element={
								<ProtectedRoute>
									<UserPanelScreen />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/profile"
							element={
								<ProtectedRoute>
									<ProfileScreen />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/treeview"
							element={
								<ProtectedRoute>
									<TreeScreen />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/adduser"
							element={
								<ProtectedRoute>
									<AddUserScreen />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/transection"
							element={
								<ProtectedRoute>
									<TransectionScreen />
								</ProtectedRoute>
							}
						></Route>
						<Route
							path="/mywallet"
							element={
								<ProtectedRoute>
									<MyWalletScreen />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/myregisterwallet"
							element={
								<ProtectedRoute>
									<MyRegisterWalletScreen />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/transferandhistory"
							element={
								<ProtectedRoute>
									<TransferandHistory />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/convert"
							element={
								<ProtectedRoute>
									<ConvertScreen />
								</ProtectedRoute>
							}
						/>
						{/* Ask for shopping balance against money paid outside the system. */}
						<Route
							path="/topup"
							element={
								<ProtectedRoute>
									<TopupScreen />
								</ProtectedRoute>
							}
						/>
						{/* Ask an upline merchant for Shopping Balance after paying them offline. */}
						<Route
							path="/request-money"
							element={
								<ProtectedRoute>
									<RequestMoneyScreen />
								</ProtectedRoute>
							}
						/>
						{/* A merchant paying out the withdraw requests routed to them. */}
						<Route
							path="/merchant/withdraw-requests"
							element={
								<ProtectedRoute>
									<MerchantWithdrawRequestsScreen />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/transfer"
							element={
								<ProtectedRoute>
									<TransferScreen />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/history"
							element={
								<ProtectedRoute>
									<HistoryScreen />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/converthistory"
							element={
								<ProtectedRoute>
									<ConvertHistoryScreen />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/transferhistory"
							element={
								<ProtectedRoute>
									<TransferHistoryScreen />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/selectgeneration"
							element={
								<ProtectedRoute>
									<SelectGeneration/>
								</ProtectedRoute>
							}
						/>
						<Route path='/incomegenerationhistory/:id' 
						element={<ProtectedRoute>
							<IncomeGenerationHistory/>
						</ProtectedRoute>} />

						<Route
							path="/receivedhistory"
							element={
								<ProtectedRoute>
									<ReceivedHistory />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/referencehistory"
							element={
								<ProtectedRoute>
									<ReferenceHistoryScreen />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/psihistory"
							element={
								<ProtectedRoute>
									<PsiHistoryScreen />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/shop"
							element={
								<ProtectedRoute>
									<ShopScreen />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/ecommerce"
							element={
								<ProtectedRoute>
									<EcommerceScreen />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/salesandpromotion"
							element={
								<ProtectedRoute>
									<SalesandPromotionScreen />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/mypromotionalstatus"
							element={
								<ProtectedRoute>
									<MyPromotionalStatus />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/mypromotionalhistory"
							element={
								<ProtectedRoute>
									<MyPromotionalHistory />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/myteampromotionalhistory"
							element={
								<ProtectedRoute>
									<MyTeamPromotionalHistory />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/withdraw"
							element={
								<ProtectedRoute>
									<WithdrawScreen />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/withdrawhistory"
							element={
								<ProtectedRoute>
									<WithdrawHistoryScreen />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/groupsaleshistory"
							element={
								<ProtectedRoute>
									<GroupSalesHistoryScreen />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/rewardhistory"
							element={
								<ProtectedRoute>
									<RewardHistory />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/sales"
							element={
								<ProtectedRoute>
									<SalesScreen />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/mysales"
							element={
								<ProtectedRoute>
									<MySalesScreen />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/createdids"
							element={
								<ProtectedRoute>
									<CreatedIdsScreen />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/todaysales"
							element={
								<ProtectedRoute>
									<TodaySalesScreen />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/globalsales"
							element={
								<ProtectedRoute>
									<GlobalSalesScreen />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/teamsales"
							element={
								<ProtectedRoute>
									<TeamSales />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/settings"
							element={
								<ProtectedRoute>
									<SettingScreen />
								</ProtectedRoute>
							}
						/>

						{/* AGENT ROUTES */}
						<Route
							path="/agent/dashboard"
							element={
								<AgentRoute>
									<AgentDashboardScreen />
								</AgentRoute>
							}
						/>
						<Route
							path="/agent/pointlog"
							element={
								<AgentRoute>
									<PointsScreen />
								</AgentRoute>
							}
						/>
						<Route
							path="/agent/orders"
							element={
								<AgentRoute>
									<OrderListScreen />
								</AgentRoute>
							}
						/>
						<Route
							path="/agent/withdraw"
							element={
								<AgentRoute>
									<AdminWithdrawScreen />
								</AgentRoute>
							}
						/>
						<Route
							path="/agent/products"
							element={
								<AgentRoute>
									<ProductListScreen />
								</AgentRoute>
							}
						/>
						{/* Developer area. Every page below sits behind ONE PIN unlock —
						    DeveloperGate reads the shared unlock, so moving between these
						    screens never re-prompts. /julkarnine stays as the entry point. */}
						<Route
							path="/julkarnine"
							element={
								<AdminRoute>
									<DeveloperGate title="Developer Settings">
										<DeveloperScreen />
									</DeveloperGate>
								</AdminRoute>
							}
						/>
						<Route
							path="/admin/app-control"
							element={
								<AdminRoute>
									<DeveloperGate title="App Control">
										<AppControlScreen />
									</DeveloperGate>
								</AdminRoute>
							}
						/>
						<Route
							path="/admin/app-releases"
							element={
								<AdminRoute>
									<DeveloperGate title="App updates">
										<AppReleasesScreen />
									</DeveloperGate>
								</AdminRoute>
							}
						/>
						<Route
							path="/admin/broadcast"
							element={
								<AdminRoute>
									<DeveloperGate title="Send a Message">
										<BroadcastScreen />
									</DeveloperGate>
								</AdminRoute>
							}
						/>
						{['/admin/message-templates', '/admin/messaging-switch'].map((path) => (
							<Route
								key={path}
								path={path}
								element={
									<AdminRoute>
										<DeveloperGate title="Message Templates">
											<MessageTemplatesScreen />
										</DeveloperGate>
									</AdminRoute>
								}
							/>
						))}
						<Route
							path="/admin/remote-control"
							element={
								<AdminRoute>
									<DeveloperGate title="Remote Control">
										<RemoteControlScreen />
									</DeveloperGate>
								</AdminRoute>
							}
						/>
						<Route
							path="/admin/otp-history"
							element={
								<AdminRoute>
									<AdminOtpHistoryScreen />
								</AdminRoute>
							}
						/>
						<Route
							path="/otphistory"
							element={
								<ProtectedRoute>
									<UserOtpHistoryScreen />
								</ProtectedRoute>
							}
						/>
						{/* Shopping Balance log: a member's own history, everyone's for admins. */}
						<Route
							path="/shopping-balance-log"
							element={
								<ProtectedRoute>
									<ShoppingBalanceLogScreen />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/admin/shopping-balance-log"
							element={
								<AdminRoute>
									<ShoppingBalanceLogScreen admin />
								</AdminRoute>
							}
						/>
						{/* Admin Routes */}
						<Route
							path="/admin/userreport/:id"
							element={
								<UserManagerRoute>
									<UserReportScreen />
								</UserManagerRoute>
							}
						/>
						<Route
							path="/admin/config"
							element={
								<AdminRoute>
									<ConfigScreen />
								</AdminRoute>
							}
						/>
						{/* Withdraw / transfer on-off switches, amount caps and
						    charges. Admin only: it gates every member's access to
						    their own balance. */}
						<Route
							path="/admin/money-controls"
							element={
								<AdminRoute>
									<MoneyControlScreen />
								</AdminRoute>
							}
						/>
						{/* Which WhatsApp/SMS messages members get, in which
						    channel order, with what text. Admin only. */}
						<Route
							path="/admin/messages"
							element={
								<AdminRoute>
									<MessageCenterScreen />
								</AdminRoute>
							}
						/>
						{/* Agents verify the payment; admins release the points. Same
						    screen, different buttons — so both URLs take either role.
						    AgentRoute alone would bounce an admin, who has no isAgent
						    flag, all the way back to their dashboard. */}
						<Route
							path="/agent/topup"
							element={
								<StaffRoute roles={['agent', 'manager']}>
									<TopupManageScreen />
								</StaffRoute>
							}
						/>
						<Route
							path="/admin/topup"
							element={
								<StaffRoute roles={['agent', 'manager']}>
									<TopupManageScreen />
								</StaffRoute>
							}
						/>
						<Route
							path="/admin/topup-settings"
							element={
								<AdminRoute>
									<TopupSettingScreen />
								</AdminRoute>
							}
						/>
						<Route
							path="/admin/profile-edit-limits"
							element={
								<AdminRoute>
									<ProfileEditLimitScreen />
								</AdminRoute>
							}
						/>
						{/* Read-only log — user managers need it as much as admins. */}
						<Route
							path="/admin/profile-edit-history"
							element={
								<UserManagerRoute>
									<ProfileEditHistoryScreen />
								</UserManagerRoute>
							}
						/>
						<Route
							path="/admin/globalsales"
							element={
								<AdminRoute>
									<GlobalSales />
								</AdminRoute>
							}
						/>
						<Route
							path="/admin/dashboard"
							element={
								<AdminRoute>
									<DashboardScreen />
								</AdminRoute>
							}
						/>
						{/* Owner business reports. Admin only, like the API behind them. */}
						<Route
							path="/admin/reports"
							element={
								<AdminRoute>
									<ReportsHomeScreen />
								</AdminRoute>
							}
						/>
						<Route
							path="/admin/reports/:key"
							element={
								<AdminRoute>
									<OwnerReportScreen />
								</AdminRoute>
							}
						/>
						{/* The product-manager panel. Its own dashboard; the manage
						    screens below are the same admin screens, opened to whoever
						    holds the matching permission. */}
						<Route
							path="/pm"
							element={
								<ProductManagerRoute>
									<ProductManagerDashboard />
								</ProductManagerRoute>
							}
						/>
						<Route
							path="/pm/reports/sales"
							element={
								<ProductManagerRoute>
									<SalesReportScreen />
								</ProductManagerRoute>
							}
						/>
						<Route
							path="/pm/reports/orders"
							element={
								<ProductManagerRoute>
									<OrderReportScreen />
								</ProductManagerRoute>
							}
						/>
						<Route
							path="/admin/products"
							element={
								<StaffRoute permissions={['canAddProduct']} roles={['productManager']}>
									<ProductListScreen />
								</StaffRoute>
							}
						/>
						{/* Stock room, delivery counter and their shared log. Open to
						    staff holding the matching permission, not just admins. */}
						<Route
							path="/admin/stock"
							element={
								<StaffRoute permissions={['canManageStock', 'canPrintSticker', 'canAddProduct']}>
									<StockScreen />
								</StaffRoute>
							}
						/>
						<Route
							path="/admin/delivery"
							element={
								<StaffRoute permissions={['canDeliver']}>
									<DeliveryScreen />
								</StaffRoute>
							}
						/>
						<Route
							path="/admin/stock-log"
							element={
								<StaffRoute permissions={['canManageStock', 'canPrintSticker', 'canDeliver', 'canAddProduct']}>
									<InventoryLogScreen />
								</StaffRoute>
							}
						/>
						<Route
							path="/mydeliveries"
							element={
								<ProtectedRoute>
									<MyDeliveryScreen />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/admin/product/new"
							element={
								<StaffRoute permissions={['canAddProduct']} roles={['productManager']}>
									<ProductEditScreen />
								</StaffRoute>
							}
						/>
						<Route
							path="/admin/product/:id"
							element={
								<StaffRoute permissions={['canAddProduct']} roles={['productManager']}>
									<ProductEditScreen />
								</StaffRoute>
							}
						/>
						<Route
							path="/admin/orders"
							element={
								<StaffRoute permissions={['canManageOrders']} roles={['productManager']}>
									<OrderListScreen />
								</StaffRoute>
							}
						/>
						{/* Full-screen genealogy viewer, opened in a new tab from the user list. */}
						<Route
							path="/admin/tree/:username"
							element={
								<AdminRoute>
									<AdminTreeScreen />
								</AdminRoute>
							}
						/>
						<Route
							path="/admin/users"
							element={
								<UserManagerRoute>
									<UserListScreen />
								</UserManagerRoute>
							}
						/>
						<Route
							path="/admin/positionhistory"
							element={
								<UserManagerRoute>
									<AdminPositionHistory />
								</UserManagerRoute>
							}
								
							
					
						/>
						<Route
							path="/admin/agents"
							element={
								<AdminRoute>
									<AgentListScreen />
								</AdminRoute>
							}
						/>
						<Route
							path="/admin/addagent"
							element={
								<AdminRoute>
									<AddAgentScreen />
								</AdminRoute>
							}
						/>
						<Route
							path="/admin/addusermanager"
							element={
								<AdminRoute>
									<AddUserManagerScreen />
								</AdminRoute>
							}
						/>
						<Route
							path="/admin/associations"
							element={
								<AdminRoute>
									<AssociationScreen />
								</AdminRoute>
							}
						/>
						<Route
							path="/admin/association-transfers"
							element={
								<AdminRoute>
									<AssociationTransferScreen />
								</AdminRoute>
							}
						/>
						<Route
							path="/admin/money-requests"
							element={
								<AdminRoute>
									<MoneyRequestsScreen />
								</AdminRoute>
							}
						/>
						<Route
							path="/admin/edituser/:id"
							element={
								<UserManagerRoute>
									<EditUser />
								</UserManagerRoute>
							}
						/>
						<Route
							path="/admin/pointlog"
							element={
								<AdminRoute>
									<PointsScreen />
								</AdminRoute>
							}
						/>
						<Route
							path="/admin/commissions"
							element={
								<AdminRoute>
									<CommissionScreen />
								</AdminRoute>
							}
						/>
						<Route
							path="/admin/availablebalance"
							element={
								<AdminRoute>
									<AvailableBalanceListScreen />
								</AdminRoute>
							}
						/>
						<Route
							path="/admin/designationlist"
							element={
								<AdminRoute>
									<DesignationListScreen />
								</AdminRoute>
							}
						/>
						<Route
							path="/admin/withdraw"
							element={
								<AdminRoute>
									<AdminWithdrawScreen />
								</AdminRoute>
							}
						/>
						<Route
							path="/admin/positionhistory"
							element={
								<UserManagerRoute>
									<AdminPositionHistory />
								</UserManagerRoute>
							}
						/>
						<Route
							path="/admin/notices"
							element={
								<AdminRoute>
									<NoticeListScreen />
								</AdminRoute>
							}
						/>
						<Route
							path="/admin/chatlist"
							element={
								<AdminRoute>
									<ChatListScreen />
								</AdminRoute>
							}
						/>
						<Route
							path="/admin/global"
							element={
								<AdminRoute>
									<GlobalScreen />
								</AdminRoute>
							}
						/>
						<Route
							path="/admin/global/distribute/:id"
							element={
								<AdminRoute>
									<DistributeScreen />
								</AdminRoute>
							}
						/>
						<Route
								path="/admin/monitor"
								element={
									<AdminRoute>
										<SystemMonitorScreen />
									</AdminRoute>
								}
							/>
							<Route
								path="/admin/backup"
								element={
									<AdminRoute>
										<BackupScreen />
									</AdminRoute>
								}
							/>
							<Route
								path="/admin/matching-history"
								element={
									<AdminRoute>
										<MatchingHistoryScreen />
									</AdminRoute>
								}
							/>
							<Route
								path="/admin/convert-history"
								element={
									<AdminRoute>
										<AdminConvertHistoryScreen />
									</AdminRoute>
								}
							/>
							<Route
								path="/admin/income-generation"
								element={
									<AdminRoute>
										<IncomeGenerationAdminScreen />
									</AdminRoute>
								}
							/>
							<Route
								path="/admin/sales-generation"
								element={
									<AdminRoute>
										<SalesGenerationAdminScreen />
									</AdminRoute>
								}
							/>
							{/* END OF ADMIN ROUTE */}
					</Routes>
				</main>
				<footer></footer>
			</div>
		</HashRouter>
	);
}

export default App;
